import { Route } from '@angular/router';
import { APP_CONSTANTS } from '../../core/constants/app.constants';
import { authGuard } from '../../core/guards/auth.guard';
import { roleGuard } from '../../core/guards/role.guard';

function practiceChildren(): Route[] {
  return [
    { path: '', loadComponent: () => import('./setup/setup').then((m) => m.Setup) },
    { path: 'history', loadComponent: () => import('./history/history-page').then((m) => m.HistoryPage) },
    { path: 'interview/:sessionId', loadComponent: () => import('./interview/interview').then((m) => m.Interview) },
    { path: 'report/:sessionId', loadComponent: () => import('./report/report').then((m) => m.ReportPage) }
  ];
}

export const practiceMockSessionRoutes: Route[] = [
  {
    path: APP_CONSTANTS.ROUTES.STUDENT_PRACTICE_MOCK_SESSION.replace(/^\//, ''),
    loadComponent: () => import('./practice-mock-session.shell').then((m) => m.PracticeMockSessionShell),
    canActivate: [authGuard, roleGuard],
    data: { roles: [APP_CONSTANTS.ROLES.STUDENT] },
    children: practiceChildren()
  }
];
